export const en = {
    all: 'For any period',
    'all-interest': 'Interests for any period',
    audience: 'Audience',
    'audience-and-metrika': 'Yandex.Audience and Yandex.Metrica',
    'audience-description':
        'You can combine different criteria accounting, for example, for user interests, income level, marital status, or visits to certain locations.',
    'audience-name': 'Audience name',
    'condition-rules-group-preview': {
        one: '{count} set of rules',
        some: '{count} sets of rules',
        many: '{count} sets of rules',
        none: ''
    },
    'condition-rules-rule-preview': {
        one: '{count} rule',
        some: '{count} rules',
        many: '{count} rules',
        none: '{count} rules'
    },
    'description-by-day': {
        one: '{description} (over {count} day)',
        some: '{description} (over {count} days)',
        many: '{description} (over {count} days)',
        none: ''
    },
    'interests-set': 'Set of interests',
    isNotSet: 'Not set',
    'long-term-interest': 'Long-term interests',
    long_term: 'Long-term',
    'no-value-description': 'Not set',
    'short-term-interest': 'Short-term interests',
    short_term: 'Short-term',
    'unavailable-goal': 'Goal not found',
    'user-profile': 'User profile',
    'user-profile-interests-description':
        'You can add three sets of short-term user interests in order to serve ads only to interested users',
    'user-profile-name': 'Profile name',
    'user-profile-no-value-description': 'Not set'
};
